
import { Component, Vue } from 'vue-property-decorator'
import { getMeterList, addMeter, putMeter, delMeter, getCompanyList, getHostList, getStorehouseList } from '@/api/admin'
import { IArticleData } from '@/api/types'
import { Form } from 'element-ui'

@Component({
  name: 'Meter',
  filters: {
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toISOString()
    }
  }
})
export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private title = '新增仪表'
  private total = 0
  private sub = ''
  private companyList = []
  private storehouseList =[]
  private hostList = []
  private listQuery = {
    page: 1,
    pagesize: 10,
    company: ''
  }
  private getListQuery = {
    page: 1,
    pagesize: 100
  }
  private initForm = {
    meterName: '',
    meterCode: '',
    storehouseId: '',
    meterInterval: '',
    state: '',
    minTem: '',
    maxTem: '',
    minHum: '',
    maxHum: '',
    companyId: '',
    hostId: ''
  }
  private form = { ...this.initForm }
  private formLabelWidth = '120px'
  private rules = {
    companyId: [
      { required: true, message: '请选择使用企业', trigger: 'change' }
    ],
    storehouseId: [
      { required: true, message: '请选择库房', trigger: 'change' }
    ],
    hostId: [
      { required: true, message: '请选择主机', trigger: 'change' }
    ],
    meterName: [
      { required: true, message: '请输入仪表名', trigger: 'blur' }
    ],
    meterCode: [
      { required: true, message: '请输入仪表编号', trigger: 'blur' }
    ],
    state: [
      { required: true, message: '请选择仪表状态', trigger: 'change' }
    ],
    minTem: [
      { required: true, message: '请输入温度下限', trigger: 'blur' }
    ],
    maxTem: [
      { required: true, message: '请输入温度上限', trigger: 'blur' }
    ],
    minHum: [
      { required: true, message: '请输入湿度下限', trigger: 'blur' }
    ],
    maxHum: [
      { required: true, message: '请输入湿度上限', trigger: 'blur' }
    ],
    meterInterval: [
      { required: true, message: '请输入采集间隔', trigger: 'blur' }
    ]
  }
  created() {
    this.getList()
    this.getCompanyList()
    this.getStorehouseList()
    this.getHostList()
  }
  // 获取企业列表
  private async getCompanyList() {
    const { data } = await getCompanyList(this.getListQuery)
    this.companyList = data.items
  }
  // 获取库房列表
  private async getStorehouseList() {
    const { data } = await getStorehouseList(this.getListQuery)
    console.log(data.items)
    this.storehouseList = data.items
  }
  // 获取主机列表
  private async getHostList() {
    const { data } = await getHostList(this.getListQuery)
    this.hostList = data.items
  }
  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getMeterList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 新增 修改
  private async changeHandel(row:any) {
    this.dialogFormVisible = true
    if (row) {
      this.title = '修改仪表'
      this.sub = 'put'
      this.form = row
      console.log(99,row)
    } else {
      this.title = '新增仪表'
      this.sub = 'add'
      this.form = this.initForm
    }
  }
  private async submitHandle() {
    (this.$refs.form as Form).validate(async(valid) => {
      if (valid) {
        if (this.sub === 'add') {
          const res = await getMeterList(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
          }
        } else {
          const res = await getMeterList(this.form)
          if (res) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
          }
        }
        this.dialogFormVisible = false
      }
    })
  }
  // 删除
  private async delHandel(id:any) {
    this.$confirm('确定要删除该仪表？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = delMeter({ id })
      if (res) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery.page = page
    this.getList()
  }
}
